import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { signOut } from 'aws-amplify/auth';
import { userAppContext } from '../../../Context/Context';
import CommonHeader from '../../../Components/Headers/Header';
import { UserContext } from '../../../types';

const LogoutPage = () => {
  const navigate = useNavigate();
  const { setIsAuthenticated, setAuthorization, setGroups } = userAppContext() as unknown as UserContext;

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await signOut();
        setIsAuthenticated(false);
        setGroups([]);
        setAuthorization('');
        navigate('/');
      } catch (error) {
        console.error('Error during logout:', error);
      } finally {
        // nothing
      }
    };

    handleLogout();
  }, [navigate, setIsAuthenticated, setAuthorization, setGroups]);

  return (
    <>
      <Helmet>
        <title>DISGENET: Logging Out</title>
        <meta name="description" content="Logging out of DISGENET." />
      </Helmet>
      <CommonHeader />
      <div>
        <div className="logout-page">
          <h1>Logging out...</h1>
        </div>
      </div>
    </>
  );
};

export default LogoutPage;
